import Error404View from '@segment/next-shared/404'

const Error = () => {
  return <Error404View />
}

export default Error
